
import { createTranslations } from '@/i18n/types';

export default createTranslations({
  en: {
    title: 'Welcome to SHOT',
    description: 'Choose how to sign in',
    openInTelegram: 'Or open in Telegram',
    loginError: 'Login failed. Please try again.',
    loginWithTelegram: 'Continue with Telegram',
    loginWithSteam: 'Continue with Steam',
    loggingIn: 'Signing you in…',
    userAgreement: 'User Agreement',
    privacyPolicy: 'Privacy Policy',
  },
  ru: {
    title: 'Добро пожаловать в SHOT',
    description: 'Выбери способ входа',
    openInTelegram: 'Или открой в Telegram',
    loginError: 'Ошибка входа. Попробуй ещё раз.',
    loginWithTelegram: 'Войти через Telegram',
    loginWithSteam: 'Войти через Steam',
    loggingIn: 'Выполняется вход…',
    userAgreement: 'Пользовательское соглашение',
    privacyPolicy: 'Политика конфиденциальности',
  },
  uz: {
    title: 'SHOTga xush kelibsiz',
    description: "Kirish usulini tanlang",
    openInTelegram: 'Yoki Telegramda oching',
    loginError: 'Kirish xatosi. Iltimos, qayta urinib koʻring.',
    loginWithTelegram: 'Telegram orqali kirish',
    loginWithSteam: 'Steam orqali kirish',
    loggingIn: 'Kirish amalga oshirilmoqda…',
    userAgreement: 'Foydalanuvchi shartnomasi',
    privacyPolicy: 'Maxfiylik siyosati',
  },
  fa: {
    title: 'به SHOT خوش آمدی',
    description: 'انتخاب کن چطور وارد شوی',
    openInTelegram: 'یا در تلگرام باز کن',
    loginError: 'ورود نشد. دوباره تلاش کن.',
    loginWithTelegram: 'ادامه با تلگرام',
    loginWithSteam: 'ادامه با استیم',
    loggingIn: 'در حال ورود…',
    userAgreement: 'شرایط استفاده',
    privacyPolicy: 'سیاست حریم خصوصی',
  },
});
